<template id="orgServiceTmpl">
	<div>
		<v-form ref="serviceFrm">
			
			<v-row no-gutters> 
				<v-col cols="12" class="text-sm-left text-md-right">
					<v-btn class="button-main" v-on:click="saveDetailsPrj()">{{ $t('btn.save')}} <v-icon right dark>cloud_upload</v-icon> </v-btn>
				</v-col>
			</v-row>

			<!-- ESTIMATE - START -->
			<v-card class="mt-3 mb-3" v-if="estimate_obj != null">
				<v-card-subtitle>{{ $t('lbl.estimate_title_temporary') }}</v-card-subtitle>
				<v-card-text>
					<v-row no-gutters> 
						<v-col cols="12">
							<strong>{{ $t('lbl.estimate_num_of_service') }}:&nbsp;{{ this.estimate_obj.num_services }}</strong>
						</v-col>
					</v-row>
					<div v-for="(amountObj, amountKey) in  this.estimate_obj.amounts" :key="amountKey" >
						<v-row no-gutters v-for="(value, currencyKey) in  amountObj" :key="currencyKey" >
							<v-col cols="12">
								<strong>{{ $t('lbl.estimate_amount_' + amountKey) }}:&nbsp;{{currencyKey}}&nbsp;{{$root.formatPrice(value)}}</strong>
							</v-col>
						</v-row>
					</div>
				</v-card-text>	
			</v-card>
			<!-- ESTIMATE - END -->

			
			<v-row no-gutters> 
				<v-col cols="12">
					<v-select :label="$t('lbl.serviceType')" :items="servicesFilterItemList" v-model="filterServiceTag" prepend-icon="filter_list" ></v-select>
				</v-col>
			</v-row>	


			<v-expansion-panels>
				<v-expansion-panel v-for="(item, indexService) in filteredItemsByTag" :key="indexService" >
					<v-expansion-panel-header>

						<div class="ma-0 ba-0 text-capitalize font-weight-bold">
							{{$root.findTranslationInList(item.service_name)}}
							
							<v-avatar v-if="isServiceActive(item.service_id)" style="color: #fff;" size="24px" color="primary" right>
								<v-icon dark>mdi-checkbox-marked-circle</v-icon>
							</v-avatar>
						</div>
						
					</v-expansion-panel-header>		

					<v-expansion-panel-content>
						
						<!-- ACTIVATE AND BUTTON DETAILS -->
						<v-row no-gutters class="mb-4">
							<v-col cols="12" md="6">
								<v-switch :input-value="isServiceActive(item.service_id)" v-on:change="activeDeactiveService(item, $event)"  :label="$t('lbl.serviceActiveDeactive')" color="primary"></v-switch>
							</v-col>
							<v-col cols="12" md="6" class="text-sm-left text-md-right">
								<v-btn class="button-main" v-on:click="openDlgServiceDetails(item)"><v-icon>list_alt</v-icon>&nbsp;{{ $t('lbl.serviceDetails') }}</v-btn>
							</v-col>
						</v-row>
						<v-divider></v-divider>

						<v-row no-gutters class="mt-4">
							<v-col cols="12" md="6" class="font-weight-bold">
								{{$t('lbl.serviceContents')}}
							</v-col>
						</v-row>

						<!-- CONTENTS - START-->
						<v-list>
							<div v-for="(contentItem, namecontent) in item.contents" :key="namecontent" >
								<v-list-item>
									<v-list-item-icon>
										<v-icon>label</v-icon>
									</v-list-item-icon>

									<v-list-item-content>
										<v-list-item-title class="font-weight-bold">{{$root.findTranslationInList(contentItem.name)}}</v-list-item-title>
											<v-row no-gutters>
												<v-col cols="12" md="6">
													<strong>{{$t('lbl.contentUnitPrice')}}:&nbsp;</strong>{{contentItem.price.currency}}&nbsp;{{$root.formatPrice(contentItem.price.value)}}
													<span v-if="!contentItem.is_multiple">&nbsp;{{$t('lbl.contentPriceNotMultiple')}}</span>
													<span v-if="contentItem.period">&nbsp;{{$t('lbl.contentPrice_' + contentItem.period)}}</span>
												</v-col>
												<v-col cols="12" md="6">
													<span v-if="isServiceActive(item.service_id)">
														<span v-if="contentItem.is_multiple">
															<v-select :items="quantityItems" :label="$t('lbl.contentQuantity')" :value="getQuantityServiceContent(item.service_id, namecontent, null)" v-on:input="updateQuantityServiceContent(item, namecontent, $event)" ></v-select>
														</span>
														<span v-else>
															<strong>{{$t('lbl.contentQuantity')}}:&nbsp;</strong>{{ getQuantityServiceContent(item.service_id, namecontent, null) }}
														</span>
													</span>
												</v-col>
											</v-row>

											<!-- ADDITIONAL CONTENTS START-->
											<v-list>
												<div v-for="(additionalContentItem, nameadditionalcontent) in contentItem.additional_contents" :key="nameadditionalcontent" >
													<v-list-item>
														<v-list-item-icon>
															<v-icon>label</v-icon>
														</v-list-item-icon>
														<v-list-item-content>
															<v-list-item-title class="font-weight-bold">{{$root.findTranslationInList(additionalContentItem.name)}}</v-list-item-title>
															<v-row no-gutters>
																<v-col cols="12" md="6">
																	<strong>{{$t('lbl.contentUnitPrice')}}:&nbsp;</strong>{{additionalContentItem.price.currency}}&nbsp;{{$root.formatPrice(additionalContentItem.price.value)}}
																	<span v-if="additionalContentItem.period">&nbsp;{{$t('lbl.contentPrice_' + additionalContentItem.period)}}</span>
																</v-col>
																<v-col cols="12" md="6">
																	<span v-if="isServiceActive(item.service_id)">
																		<span v-if="additionalContentItem.is_multiple">
																			<v-select :items="quantityItems" :label="$t('lbl.contentQuantity')" :value="getQuantityServiceContent(item.service_id, namecontent, nameadditionalcontent)" v-on:input="updateQuantityServiceAdditionalContent(item, namecontent, nameadditionalcontent, $event)" ></v-select>
																		</span>
																		<span v-else>
																			<strong>{{$t('lbl.contentQuantity')}}:&nbsp;</strong>{{ getQuantityServiceContent(item.service_id, namecontent, nameadditionalcontent) }}
																		</span>
																	</span>
																</v-col>
															</v-row> 	
														</v-list-item-content>	
													</v-list-item>
												</div>
											</v-list>
											<!-- ADDITIONAL CONTENTS END-->

									</v-list-item-content>
									
								</v-list-item>

								<v-divider></v-divider>

							</div>
						</v-list>
						<!-- CONTENTS - END-->

						<!-- IF ACTIVE - USER NOTES -->	
						<v-layout row wrap v-if="isServiceActive(item.service_id)">
							<v-flex xs12>
								<v-textarea :value="getNoteService(item.service_id)" :label="$t('lbl.serviceNote')" v-on:input="updateNoteService(item, $event)" outline></v-textarea>
							</v-flex> 
						</v-layout>
					
					</v-expansion-panel-content>
					
				</v-expansion-panel>
			</v-expansion-panels>	
		</v-form>

		<!--  DIALOG SCHEDA TECNICA START-->
		<v-dialog v-model="dlgServiceDetailsIsOpen" max-width="700px" v-if="serviceObjDlg != null">
			<v-card>
				<v-card-title>{{ $t('lbl.serviceDetails') }}</v-card-title>	
				<v-card-text>
						
						<v-row no-gutters>
							<v-col cols="12">
								<span class="font-weight-bold">{{ $t('lbl.serviceCode') }}: </span>{{serviceObjDlg.service_id}}
							</v-col>
						</v-row>
						<v-row no-gutters class="mt-3">
							<v-col cols="12" class="font-weight-bold">
								{{$root.findTranslationInList(serviceObjDlg.service_name)}}
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col cols="12">
								{{$root.findTranslationInList(serviceObjDlg.service_description)}}
							</v-col>
						</v-row>
						
						<v-divider></v-divider>

						<v-row no-gutters>
							<v-col cols="12">
								<span class="font-weight-bold">{{ $t('lbl.serviceType') }}: </span>
							</v-col>
							<v-col cols="12" v-for="(tagTmp, indexTag) in serviceObjDlg.tags" :key="indexTag">
							- {{findTranslationInList(tagTmp) }}
							</v-col>
						</v-row>
						<v-divider></v-divider>

						<!-- SERVICE DETAIL DLG - CONTENTS - START -->
						<div v-for="(contentItem, namecontent) in serviceObjDlg.contents" :key="namecontent" >
							<v-row no-gutters>
								<v-col cols="12" class="font-weight-bold">
									{{$root.findTranslationInList(contentItem.name)}}
								</v-col>
							</v-row>
							<v-row no-gutters>	
								<v-col cols="12">
									{{$t('lbl.contentUnitPrice')}}:&nbsp;{{contentItem.price.currency}}&nbsp;{{$root.formatPrice(contentItem.price.value)}}
									<span v-if="!contentItem.is_multiple">&nbsp;{{$t('lbl.contentPriceNotMultiple')}}</span>
									<span v-if="contentItem.period">&nbsp;{{$t('lbl.contentPrice_' + contentItem.period)}}</span>
								</v-col>
							</v-row>
							<!-- SERVICE DETAIL DLG - ADDITIONAL CONTENTS START-->
							<div v-for="(additionalContentItem, nameadditionalcontent) in contentItem.additional_contents" :key="nameadditionalcontent" >
								<v-row no-gutters class="pl-4">
									<v-col cols="12" class="font-weight-bold">
										<span class="font-weight-bold">{{$root.findTranslationInList(additionalContentItem.name)}}</span>
									</v-col>
								</v-row>
								<v-row no-gutters class="pl-4">
									<v-col cols="12">
										{{$t('lbl.contentUnitPrice')}}:&nbsp;{{additionalContentItem.price.currency}}&nbsp;{{$root.formatPrice(additionalContentItem.price.value)}}
										<span v-if="additionalContentItem.period">&nbsp;{{$t('lbl.contentPrice_' + additionalContentItem.period)}}</span>
									</v-col>
								</v-row>	
							</div>		
							<!-- SERVICE DETAIL DLG - ADDITIONAL CONTENTS END-->
						</div>
						<v-divider></v-divider>
						<!-- SERVICE DETAIL DLG - CONTENTS - END -->

						<!-- SERVICE DETAIL DLG - NOTE HTML -->
						<div v-if="$root.findTranslationInList(serviceObjDlg.service_notes) != ''">
							<v-row no-gutters>
								<v-col cols="12">
									<span class="font-weight-bold">{{ $t('lbl.serviceNoteHtml') }}</span>
								</v-col>
							</v-row>
							<v-row no-gutters class="mt-3 mb-3">
								<v-col cols="12">
									<div v-html="$root.findTranslationInList(serviceObjDlg.service_notes)"></div>
								</v-col>
							</v-row>
						</div>


				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn class="button-main ma-1" v-on:click="closeDlgServiceDetails()"><v-icon left dark>close</v-icon>{{ $t('btn.closeDialog')}}</v-btn>
				</v-card-actions>			
			</v-card>	
		</v-dialog>
		<!--  DIALOG SCHEDA TECNICA END-->
				
	</div>					
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
	i18n,
    data: () => ({
		minQuantityService: 1,
		maxQuantityService: 100,
		filterServiceTag: "all",
		quantityItems:[],
		pricesHeaders: [
			{ text: '', align: 'center'}, 
			{ text: '', align: 'center'}, 
		],
		services_cart:[],
		estimate_obj: null,
		dlgServiceDetailsIsOpen: false,
		serviceObjDlg: null
	}),
	props: ['orgitem', 'prjitem', 'servicesList', 'servicesFilterItemList'],
	components: 
	{
        
	},
	created() 
	{
		
	},
	beforeMount() 
	{
		for (var i = this.minQuantityService; i <= this.maxQuantityService; i++) 
		{
			this.quantityItems.push(i);
		}
	},
	mounted() 
	{
		//=== START LISTEN EVENTS
		events.$on(constants.EVENT_DO_INIT_CART, (servicesOfPrj, servicesList) => {
			this.initCart(servicesOfPrj, servicesList);
		});

		//=== STARTUP
		this.estimate_obj = this.getEmptyEstimateObj();

		//=== SE IL PROGETTO VIENE CARICATO PRIMA DELL EVENTO
		if(!this.isEmptyObj(this.prjitem) && !this.isEmptyObj(this.prjitem.services) && !this.isEmptyObj(this.servicesList) && Array.isArray(this.servicesList) && this.servicesList.length > 0 )
		{
			this.initCart(this.prjitem.services, this.servicesList);
		}
	},
	destroyed() 
	{
		//=== STOP LISTEN EVENTS
		events.$off(constants.EVENT_DO_INIT_CART);
	},		
	computed: 
	{
		filteredItemsByTag() 
		{
			if(this.filterServiceTag != 'all' )
			{
				return this.servicesList.filter((i) => {
					//return !this.servicesList || (i.tags.includes(this.filterServiceTag));
					if(i!= null && i!= undefined){
						for (var j = 0; j < i.tags.length; j++) 
						{
							var valTmp = i.tags[j][i18n.locale];
							if(valTmp!= null && valTmp!= undefined && valTmp == this.filterServiceTag)
							{
								return true;
							}
						}
						return false;
					} 
					else 
					{
						return false;
					}
				});
			} 
			else 
			{
				return this.servicesList;
			}
		}
	},
	methods: 
	{
		initCart(prjServices, servicesList) 
		{
			//alert("AGGIORNO CARRELLO:" + JSON.stringify(servicesList));

			// SU NUOVO PROGETTO E' UNDIFINED
			if(!this.isEmptyObj(prjServices))
			{
				// DEVO CICLARE E NON METTERCELA TUTTA ALTRIMENTI ME LA METTE PER RIFERIMENTO
				// INVECE NE VOGLIO UNA COPIA
				this.services_cart = [];
				for (var i = 0; i < prjServices.length; i++) 
				{
					var serviceObj = prjServices[i];	
				
					var obj2add = this.getEmptyCartElement();
					obj2add.service_id = serviceObj.service_id;

					// PRENDO OGGETTO SERVIZIO DA PROGETTO
					//obj2add.service = serviceObj.service;
					
					// PRENDO OGGETTO SERVIZIO DA CATALOGO
					obj2add.service = this.findServiceObjInCatalogue(serviceObj.service_id, servicesList);
					if(!this.isEmptyObj(obj2add.service))
					{
						// VADO AVANTI SOLO SE ESISTE SUL CATALGO
						obj2add.notes = serviceObj.notes;
						obj2add.contents_data = serviceObj.contents_data;
						
						this.services_cart.push(obj2add);
					}
				}
				
				//=== AGGIORNO PREVENTIVO PROVVISORIO
				this.estimate_obj = this.calculateEstimate(this.services_cart, servicesList, true);
			} 
		},
		saveDetailsPrj() 
		{
			var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + this.orgitem.organization_id + '/projects/' + this.prjitem.project_id;
			var obj2send = this.prjitem;
			// SE VOGLIO SALVARE ANCHE L'OGGETTO SERVICE
			//obj2send.services = this.services_cart;

			// NON SALVANDO SERVICE OBJ
			var services2send = [];
			for (var i = 0; i < this.services_cart.length; i++) 
			{
				var serviceObj = this.services_cart[i];	
			
				var obj2add = {};
				obj2add.service_id = serviceObj.service_id;
				obj2add.notes = serviceObj.notes;
				obj2add.contents_data = serviceObj.contents_data;
				
				services2send.push(obj2add);
			}
			obj2send.services = services2send;

			this.$root.genericPutAuthenticatedCallEngine(endpoint2go, obj2send, this.callbackSaveDetailsPrj);
		},
		callbackSaveDetailsPrj(responseData) 
		{
			//=== LANCIO EVENTO RICARICA PROGETTO
			events.$emit(constants.EVENT_DO_LOAD_PRJ_DETAILS);
			
			this.$root.changesNotSavedFlg = false;
			this.$root.setDialogMsg(i18n.t('msg.saveok'));
		},
		isServiceActive(serviceId)
		{
			return (this.getServiceIndexIntoCart(serviceId) >= 0);
		},
		getQuantityServiceContent(serviceId, namecontent, additionalnamecontent)
		{
			var itemInCart = this.findServiceObjInCart(serviceId);
			//alert("getQuantityServiceContent ["+serviceId+"]["+namecontent+"]["+additionalnamecontent +"] OBJ: "+ JSON.stringify(itemInCart));
			if(!this.isEmptyObj(itemInCart))
			{
				var quantity = this.getQuantityServiceContentByServiceObjWithContentData(itemInCart, namecontent, additionalnamecontent, 0);
				return quantity;
			}
			else 
			{
				return 0;
			}
		},
		getNoteService(serviceId)
		{
			var index = this.getServiceIndexIntoCart(serviceId);
			if(index >= 0)
			{
				var itemInCart = this.services_cart[index];
				if(!this.isEmptyObj(itemInCart) && !this.isEmptyString(itemInCart.notes))
				{
					return itemInCart.notes.it_IT;
				} 
				else 
				{
					return "";
				}
			} 
			else 
			{
				return "";
			}
		},
		activeDeactiveService(serviceObj, evento)
		{
			try{
				this.$root.loading = true;
				
				var index = this.getServiceIndexIntoCart(serviceObj.service_id); 
				if(evento == true && index < 0)
				{
					//console.log("DEVO AGGIUNGERE");

					var obj2add = this.getEmptyCartElement();
					obj2add.service_id = serviceObj.service_id;
					obj2add.service = serviceObj;

					//=== METTO QUANTITA AD UNO PER TUTTI I CONTENTS ED ADDITIONAL CONTENT DEL SERVIZIO
					for(var namecontent in serviceObj.contents)
					{
						var elem2add = {"quantity": 1};
						var contentObj = serviceObj.contents[namecontent];

						//=== CICLO ADDITIONAL CONTENTS
						if(!this.isEmptyObj(contentObj) && !this.isEmptyObj(contentObj.additional_contents))
                        {
							for(var nameadditionalcontent in contentObj.additional_contents)
							{
								// ANCHE PER GLI ADDITIONA CONTENTS CON QUANTITA AUTONOMA
								elem2add[nameadditionalcontent] = {"quantity": elem2add.quantity};
							}
						}
						obj2add.contents_data[namecontent] = elem2add;
					}

					this.services_cart.push(obj2add);

					this.$root.changesNotSavedFlg = true;

					//=== AGGIORNO PREVENTIVO PROVVISORIO
					this.estimate_obj = this.calculateEstimate(this.services_cart, this.servicesList, true);

				} 
				else if(evento == false && index >= 0)
				{
					//console.log("DEVO RIMUOVERE");

					this.services_cart.splice( index, 1 );
					
					this.$root.changesNotSavedFlg = true;

					//=== AGGIORNO PREVENTIVO PROVVISORIO
					this.estimate_obj = this.calculateEstimate(this.services_cart, this.servicesList, true);

				}
			} catch(err) {
				console.log(err);
			} finally {
				this.$root.loading = false;
			}
		},
		updateQuantityServiceContent(serviceObj, namecontent, evento)
		{
			//alert("updateQuantityServiceContent: " + evento);
			try{
				var index = this.getServiceIndexIntoCart(serviceObj.service_id); 
				if(index >= 0)
				{
					var itemInCart = this.services_cart[index];
					if(!this.isEmptyObj(itemInCart))
					{
						//===  Devo appoggiare su una lista provvisoria altrimenti non si aggiorna
						var servicesCartTmp = this.services_cart;
						
						//=== SE CONTENT DATA FOSSE NULL, LA CREO
						if(this.isEmptyObj(servicesCartTmp[index].contents_data))
						{
							servicesCartTmp[index].contents_data = {};
						}

						//=== NUOVO OGGETTO
						var elem2add = {"quantity": evento};
						var contentObj = serviceObj.contents[namecontent];

						//=== CICLO ADDITIONAL CONTENTS
						if(!this.isEmptyObj(contentObj) && !this.isEmptyObj(contentObj.additional_contents))
                        {
							for(var nameadditionalcontent in contentObj.additional_contents)
							{
								var additionalContentObj = contentObj.additional_contents[nameadditionalcontent];
								
								//alert(JSON.stringify(additionalContentObj));

								if(!additionalContentObj.is_multiple)
								{
									// ADDITIONAL CONTENT NON AUTONOMO
									elem2add[nameadditionalcontent] = {"quantity": elem2add.quantity};
								} 
								else 
								{
									// ADDITIONAL CONTENT CON QUANTITA AUTONOMA
									var additonalContentBeforeQty = this.getQuantityServiceContent(serviceObj.service_id, namecontent, nameadditionalcontent);
									elem2add[nameadditionalcontent] =  {"quantity": additonalContentBeforeQty};
								}
							}
						}
						servicesCartTmp[index].contents_data[namecontent] = elem2add;

						//=== RI-SETTO CARRELLO
						this.services_cart = [];
						this.services_cart = servicesCartTmp;

						this.$root.changesNotSavedFlg = true;

						//=== AGGIORNO PREVENTIVO PROVVISORIO
						this.estimate_obj = this.calculateEstimate(this.services_cart, this.servicesList, true);
					} 
				}
			} catch(err) {
				console.log(err);
			} finally {
				this.$root.loading = false;
			}
		},
		updateQuantityServiceAdditionalContent(serviceObj, namecontent, nameadditionalcontent, evento)
		{
			try{
				var index = this.getServiceIndexIntoCart(serviceObj.service_id); 
				if(index >= 0)
				{
					var itemInCart = this.services_cart[index];
					if(!this.isEmptyObj(itemInCart))
					{
						//===  Devo appoggiare su una lista provvisoria altrimenti non si aggiorna
						var servicesCartTmp = this.services_cart;
						
						//=== SE CONTENT DATA FOSSE NULL, LA CREO
						if(this.isEmptyObj(servicesCartTmp[index].contents_data))
						{
							servicesCartTmp[index].contents_data = {};
						}
						//=== SE CONTENT DATA DEL CONTENT FOSSE NULL, LA CREO
						if(this.isEmptyObj(servicesCartTmp[index].contents_data[namecontent]))
						{
							servicesCartTmp[index].contents_data[namecontent] = {"quantity": 1};
						}
						var elem2add = {"quantity": evento};
						servicesCartTmp[index].contents_data[namecontent][nameadditionalcontent] = elem2add;
						
						//=== RI-SETTO CARRELLO
						this.services_cart = [];
						this.services_cart = servicesCartTmp;

						this.$root.changesNotSavedFlg = true;

						//=== AGGIORNO PREVENTIVO PROVVISORIO
						this.estimate_obj = this.calculateEstimate(this.services_cart, this.servicesList, true);
					} 
				}
			} catch(err) {
				console.log(err);
			} finally {
				this.$root.loading = false;
			}	
		},
		updateNoteService(serviceObj, evento)
		{
			try{
				var index = this.getServiceIndexIntoCart(serviceObj.service_id); 
				if(index >= 0)
				{
					var itemInCart = this.services_cart[index];
					if(!this.isEmptyObj(itemInCart))
					{
						// Devo appoggiare su una lista provvisoria altrimenti non si aggiorna
						var servicesCartTmp = this.services_cart;

						// Modifico Valore
						servicesCartTmp[index].notes.it_IT = evento;

						// Risetto carrello
						this.services_cart = [];
						this.services_cart = servicesCartTmp;

						this.$root.changesNotSavedFlg = true;
					} 
				}
			} catch(err) {
				console.log(err);
			} finally {
				this.$root.loading = false;
			}
		},
		openDlgServiceDetails(serviceObj)
		{
			this.dlgServiceDetailsIsOpen = true;
			this.serviceObjDlg = serviceObj;
		
		},
		closeDlgServiceDetails()
		{
			this.dlgServiceDetailsIsOpen = false;
			this.serviceObjDlg = null;
		
		},
		//=== UTILITIES
		getServiceIndexIntoCart(serviceId)
		{
			try{
				
				if(!this.isEmptyObj(this.services_cart) && this.services_cart.length > 0 )
				{	
					for (var i = 0; i < this.services_cart.length; i++) 
					{
						var serviceObj = this.services_cart[i];	
						
						if(serviceObj.service_id == serviceId)
						{
							return i;
						}
					}
					return -1;
				} 
				else 
				{
					return -1;
				}
			} 
			catch(err) 
			{
				console.log(err);
				return -1;
			}
		},
		findServiceObjInCart(serviceId)
		{
			for (var i = 0; i < this.services_cart.length; i++) 
			{
				var serviceObj = this.services_cart[i];	
				
				if(serviceObj.service_id == serviceId)
				{
					return serviceObj;
				}
			}
			return null;
		},
		getMyCurrentCart()
		{
			return this.services_cart;
		}	
	}	
}
</script>